// UI-2b, decision 50: priority colours. Low (blue), Medium (orange), High (strong coral with a
// small --danger dot), always with --ink text: 13.48:1, 10.64:1 and 9.70:1 (WCAG AA is 4.5:1).
// One list, used by the priority StatusPill, a priority SegmentedControl and priority chips, so
// the three can never disagree.
import React from 'react';
import './v2.css';

export const PRIORITY_LEVELS = ['low', 'medium', 'high'];

// The options for a SegmentedControl or ChipGroup: [{ value, label, color, dot }].
export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low', color: 'priority-low' },
  { value: 'medium', label: 'Medium', color: 'priority-medium' },
  { value: 'high', label: 'High', color: 'priority-high', dot: true },
];

// The small --danger dot that marks High. Decorative: the word carries the meaning.
export function PriorityDot() {
  return <span className="ui-priority-dot" aria-hidden="true" />;
}
